import { render, staticRenderFns } from "./limitWarningSet.vue?vue&type=template&id=267ae767&scoped=true&"
import script from "./limitWarningSet.vue?vue&type=script&lang=js&"
export * from "./limitWarningSet.vue?vue&type=script&lang=js&"
import style0 from "./limitWarningSet.vue?vue&type=style&index=0&id=267ae767&lang=less&scoped=true&"
import style1 from "./limitWarningSet.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267ae767",
  null
  
)

component.options.__file = "limitWarningSet.vue"
export default component.exports